import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

import { useApi } from "../contexts/ApiProvider";
import { useFlash } from "../contexts/FlashProvider";
import {
  fallbackServices as serviceFallbacks,
  getServiceImageUrl,
  normalizeService,
} from "../helpers/serviceFallbacks";

export default function Highlights({ content = {} }) {
  const api = useApi();
  const flash = useFlash();
  const fallbackList = useMemo(
    () => serviceFallbacks.slice(0, 6),
    []
  );

  const [services, setServices] = useState(fallbackList);

  useEffect(() => {
    (async () => {
      const response = await api.get("/api/services/search");
      if (response.success && response?.services?.length) {
        setServices(response.services.slice(0, 6).map(normalizeService));
      } else if (response.error) {
        flash(response.error.message || "Services indisponibles", "warning");
      }
    })();
  }, [api, flash]);

  return (
    <section className="py-7 py-lg-10">
      <div className="container">
        <div className="row align-items-end mb-5">
          <div className="col-12 col-lg-7">
            <p className="section-kicker mb-3">
              {content.kicker || "Nos domaines d'intervention"}
            </p>
            <h2 className="section-heading mb-0">
              {content.title ||
                "Des expertises organisées autour de vos enjeux prioritaires."}
            </h2>
          </div>
          <div className="col-12 col-lg-5 mt-4 mt-lg-0 text-lg-end">
            <Link to="/contact" className="btn btn-outline-dark">
              {content.cta || "Recevoir une proposition"}
            </Link>
          </div>
        </div>

        <div className="row g-4">
          {services.map((service, index) => (
            <div className="col-12 col-md-6 col-xl-4" key={service._id || service.slug}>
              <article className="service-card">
                <div className="service-card-media">
                  <img
                    src={getServiceImageUrl(service)}
                    alt={service.title}
                  />
                </div>
                <div className="p-4 p-lg-5">
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    {service.tags.map((tag) => (
                      <span className="service-tag" key={`${service.slug}-${tag}`}>
                        {tag}
                      </span>
                    ))}
                  </div>
                  <h3 className="h4 fw-bold mb-3">{service.title}</h3>
                  <p className="text-muted mb-4">{service.description}</p>
                  <div className="service-card-checks">
                    <span>Diagnostic du besoin</span>
                    <span>Solution adaptée</span>
                    <span>Suivi après cadrage</span>
                  </div>
                  <Link
                    className="fw-bold text-decoration-none"
                    to={`/services/${service.slug}`}
                  >
                    Explorer l'offre <span aria-hidden="true">&rarr;</span>
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
